import { api as globalApi } from "app/slice";
import { api as loginApi } from "app/pages/Customer/Login/slice";
import { api as dashboardApi } from "app/pages/Customer/Dashboard/slice";
import { api as digitalSecurityCurrentAndUpgradePlansApi } from "app/pages/Customer/Dashboard/slice/digitalSecurityCurrentAndUpgradePlans";
import { api as simServiceApi } from "app/pages/Customer/SimService/slice";
import { api as paymentHistoryApi } from "app/pages/Customer/PaymentHistory/slice";
import { api as quickRechargeApi } from "app/pages/Customer/QuickRecharge/slice";
import { api as forgotPasswordApi } from "app/pages/Customer/ForgotPassword/slice";
import { api as digitalSecurityPlansApi } from "app/pages/Customer/DigitalSecurity/slice";
import { api as manageProfileApi } from "app/pages/Customer/ManageProfile/slice";
import {api as submitTickerApi} from "app/pages/Customer/SubmitTicket/slice";

export const rtkQueryMiddleware = [
  globalApi.middleware,
  loginApi.middleware,
  dashboardApi.middleware,
  digitalSecurityCurrentAndUpgradePlansApi.middleware,
  simServiceApi.middleware,
  paymentHistoryApi.middleware,
  quickRechargeApi.middleware,
  forgotPasswordApi.middleware,
  digitalSecurityPlansApi.middleware,
  manageProfileApi.middleware,
  submitTickerApi.middleware,
];
